import { render, staticRenderFns } from "./base_snackbar.vue?vue&type=template&id=39e8fdaf&scoped=true&"
import script from "./base_snackbar.vue?vue&type=script&lang=ts&"
export * from "./base_snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./base_snackbar.vue?vue&type=style&index=0&id=39e8fdaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e8fdaf",
  null
  
)

export default component.exports